import React, { useState } from 'react';
import './Graphique.css';
import Bouton from '../Form/Bouton';
import CarreBilan from './CarreBilan';

const ContenueCardBilan = ({ logo, titre, titregras, totalConsumption }) => {
  const [showMore, setShowMore] = useState(false);

  const handleContribution = () => {
    window.open("https://donate.goodplanet.org/contribution-carbone/~mon-don?...", '_blank');
  };

  const handleToggleMore = () => {
    setShowMore(!showMore);
  };

  const handleEnSavoirPlus = () => {
    window.open("https://www.goodplanet.org/fr/contribution-a-la-neutralite-carbone-mondiale-tout-pour-comprendre-notre-nouvelle-demarche/", '_blank');
  };

  return (
    <div className="conteneur-card-bilan">
      <div className="bloc-texte">
        {!showMore ? (
  <p className="p1" style={{ marginBottom: "3vh", marginTop: "0vh" }}>
    En contribuant à la neutralité carbone mondiale avec la Fondation GoodPlanet, vous soutenez des projets d’évitement des émissions de gaz à effet de serre portés par des entités à but social s’inscrivant dans une démarche de solidarité internationale et d’intérêt général.
    <br /><br />
    La Fondation GoodPlanet accompagne les projets de biogaz en Inde, de cuiseurs solaires en Bolivie et de valorisation des ordures ménagères à Madagascar...&nbsp;
    <span
      className="voir-plus-toggle"
      onClick={handleToggleMore}
      style={{
        cursor: "pointer",
        color: "rgb(235, 224, 133)",
        fontWeight: "bold",
        fontSize:
          window.innerWidth < 640 ? "10px" :
          window.innerWidth < 1200 ? "12px" : "16px"
      }}
    >
      Voir plus
    </span>
  </p>
) : (
  <p className="p1" style={{ marginBottom: "3vh", marginTop: "0vh" }}>
    En contribuant à la neutralité carbone mondiale avec la Fondation GoodPlanet, vous soutenez des projets d’évitement des émissions de gaz à effet de serre portés par des entités à but social s’inscrivant dans une démarche de solidarité internationale et d’intérêt général.
    <br /><br />
    La Fondation GoodPlanet accompagne les projets de biogaz en Inde, de cuiseurs solaires en Bolivie et de valorisation des ordures ménagères à Madagascar.
    <br /><br />
    État, individus et entreprises doivent travailler main dans la main pour réduire les émissions de gaz à effet de serre et augmenter les puits de carbone dans l’objectif d’atteindre une neutralité carbone mondiale, et s’aligner avec l’Accord de Paris.
    <br /><br />
    Anciennement dénommée « compensation carbone volontaire », la contribution à la neutralité carbone est un mécanisme qui permet à une organisation ou à un particulier de financer un projet de réduction ou de séquestration de CO₂.
    <br /><br />
    <span
      className="voir-plus-toggle"
      onClick={handleToggleMore}
      style={{
        cursor: "pointer",
        color: "rgb(235, 224, 133)",
        fontWeight: "bold",
        fontSize:
          window.innerWidth < 640 ? "10px" :
          window.innerWidth < 1200 ? "12px" : "16px"
      }}
    >
      Réduire
    </span>
  </p>
)}

        

        <button type="button" className="custom-button" onClick={handleEnSavoirPlus}>
          EN savoir plus sur les projets et la contribution
        </button>
      </div>

      <div className="bloc-carre">
        <CarreBilan totalConsumption={totalConsumption} handleContribution={handleContribution} />
      </div>
    </div>
  );
};

export default ContenueCardBilan;
